import React, { useState } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { Toaster } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [user, setUser] = useState("");
  const [pass, setPass] = useState("");

  const onSubmit = (e) => {
    e.preventDefault();
    const ok = login(user, pass);
    if (ok) nav("/config");
  };

  return (
    <div className="min-h-screen bg-[#0b1b34] text-white flex items-center justify-center px-4">
      <Toaster richColors position="top-right" />
      <Card className="w-full max-w-md bg-white/5 backdrop-blur-2xl border-white/10">
        <CardHeader>
          <CardTitle className="text-white">Login do Administrador</CardTitle>
          <CardDescription className="text-white/70">Acesse as configurações do site</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={onSubmit} className="grid gap-4">
            <div className="grid gap-2">
              <Label htmlFor="user" className="text-white">Usuário</Label>
              <Input id="user" className="bg-white/10 border-white/20 text-white placeholder-white/50" placeholder="admin" value={user} onChange={(e) => setUser(e.target.value)} />
            </div>
            <div className="grid gap-2">
              <Label htmlFor="pass" className="text-white">Senha</Label>
              <Input id="pass" type="password" className="bg-white/10 border-white/20 text-white placeholder-white/50" placeholder="••••••••" value={pass} onChange={(e) => setPass(e.target.value)} />
            </div>
            <Button type="submit" className="bg-yellow-400 text-black hover:bg-yellow-300">Entrar</Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
